import React, { Component } from "react";
import { observer } from "mobx-react";
import "static-file/css/ordernoti.css";
import { aesDecoding, comma } from "../../utils/Utils";
import {
  fn_bridge_order_detail,
  fn_bridge_order_state,
  fn_bridge_new_detail_notify_baemin,
  fn_bridge_new_order_notify_baemin,
  fn_notify_close,
} from "../../function/FnPosBridge";
import LayerStore from "../../stores/LayerStore";
import SearchStore from "../../stores/SearchStore";
import ViewStore from "../../stores/ViewStore";
import SettingStore from "../../stores/SettingStore";
import OrderStore from "../../stores/OrderStore";
import { analyticeEvent, baeminMobileOrderFg, partnerIconFg, hungryPandaMobileOrderFg } from "utils/Utils";
import { fn_log_error } from "function/FnPosBridge";

@observer
class PosNotify extends Component {
  constructor(props) {
    super(props);
    this.orderJson = JSON.parse(aesDecoding(atob(props.match.params.orderNo)));
    fn_log_error("", "notifyJson", aesDecoding(atob(props.match.params.orderNo)));

    this.rootStore = {
      layerStore: LayerStore,
      searchStore: SearchStore,
      viewStore: ViewStore,
      settingStore: SettingStore,
      orderStore: OrderStore,
    };

    let setMin;
    let timeList = [];

    if (this.orderJson.morderTypeCd === "D") {
      setMin = this.orderJson.deliveryDfTime;
      if (
        !(
          this.orderJson.localDeliveryDfTime == "" ||
          this.orderJson.localDeliveryDfTime == null ||
          this.orderJson.localDeliveryDfTime == "null"
        )
      ) {
        setMin = this.orderJson.localDeliveryDfTime;
      }
    } else {
      setMin = this.orderJson.cookingDfTime;
      if (
        !(
          this.orderJson.localCookingDfTime == "" ||
          this.orderJson.localCookingDfTime == null ||
          this.orderJson.localCookingDfTime == "null"
        )
      ) {
        setMin = this.orderJson.localCookingDfTime;
      }
    }

    //헝그리판다 조리시간 입력
    if (hungryPandaMobileOrderFg(this.orderJson.mobileOrderFg)) {
      setMin = this.orderJson.cookingDfTime;
      if (
        !(
          this.orderJson.localCookingDfTime == "" ||
          this.orderJson.localCookingDfTime == null ||
          this.orderJson.localCookingDfTime == "null"
        )
      ) {
        setMin = this.orderJson.localCookingDfTime;
      }
    }

    if (this.orderJson.mobileOrderFg == "31") {
      if (this.orderJson.isInputCookingTime) {
        let time = ["5", "10", "15", "20", "25", "30"];
        let num = Number(this.orderJson.estimatedCookingTime);

        if (num < 5) {
          timeList = time;
          setMin = timeList[0];
        } else if (num > 30) {
          setMin = this.orderJson.estimatedCookingTime;
        } else {
          timeList = time.filter(val => num <= Number(val));
          setMin = timeList[0];
        }
      } else {
        setMin = this.orderJson.estimatedCookingTime;
      }
    }

    if (this.orderJson.mobileOrderFg == "27" && this.orderJson.morderTypeCd == "P") {
      if (this.orderJson.isInputCookingTime) {
        let time = ["5", "10", "15", "20", "25", "30", "40", "45", "50", "60"];
        let num = Number(this.orderJson.estimatedCookingTime);

        if (num < 5) {
          timeList = time;
          setMin = timeList[0];
        } else if (num > 60) {
          setMin = this.orderJson.estimatedCookingTime;
        } else {
          timeList = time.filter(val => num <= Number(val));
          setMin = timeList[0];
        }
      } else {
        setMin = this.orderJson.estimatedCookingTime;
      }
    }

    this.rootStore.settingStore.setCookTimeYgy(setMin);
    this.rootStore.settingStore.setCookTimeList(timeList);
    this.state = { min: Number(setMin), time: timeList };
  }

  ygyminPlus = () => {
    if (this.state.min < this.state.time[this.state.time.length - 1]) {
      let cnt = 0;
      this.state.time.map((item, index) => {
        if (this.state.min == item) {
          cnt = index + 1;
        }
      });
      this.setState({ min: Number(this.state.time[cnt]) });
    }
  };

  ygyminMinus = () => {
    if (this.state.min > this.state.time[0]) {
      let cnt = 0;
      this.state.time.map((item, index) => {
        if (this.state.min == item) {
          cnt = index - 1;
        }
      });
      this.setState({ min: Number(this.state.time[cnt]) });
    }
  };

  minPlus = () => {
    const time = ["0", "5", "10", "15", "20", "30", "45", "60", "90", "120"];
    if (this.state.min != "120") {
      let cnt = 0;
      time.map((item, index) => {
        if (this.state.min == item) {
          cnt = index + 1;
        }
      });
      this.setState({ min: Number(time[cnt]) });
    }
  };

  minMinus = () => {
    const time = ["0", "5", "10", "15", "20", "30", "45", "60", "90", "120"];
    if (this.state.min != "0") {
      let cnt = 0;
      time.map((item, index) => {
        if (this.state.min == item) {
          cnt = index - 1;
        }
      });
      this.setState({ min: Number(time[cnt]) });
    }
  };

  render() {
    this.rootStore.layerStore.setLayerLoadingView(false);
    let img_icon = partnerIconFg(this.orderJson);

    let typeElement;
    switch (this.orderJson.morderTypeCd) {
      case "D":
        typeElement = (
          <strong className="type delivery">
            배달{this.orderJson.mobileOrderFg == "31" ? "(" + this.orderJson.selfDeliveryType + ")" : ""}
          </strong>
        );
        break;
      case "P":
        typeElement = <strong className="type takeout">포장</strong>;
        break;
      case "T":
        typeElement = <strong className="type table">매장</strong>;
        break;
      case "O":
        typeElement = <strong className="type table">매장</strong>;
        break;
      default:
        break;
    }

    return (
      <>
        {baeminMobileOrderFg(this.orderJson.mobileOrderFg) ? (
          <>
            <div className="wrap_order">
              <div
                className="header"
                onClick={event => {
                  fn_bridge_order_detail(this.rootStore, this.orderJson.mobileOrderNo);
                }}
              >
                <h1>
                  <span className="img">
                    <img src={img_icon} width="32" height="32" alt={"logo"} />
                  </span>
                  {typeElement}
                  <strong className="tit">
                    총 {comma(this.orderJson.orderTotAmount.toString())}원
                    {this.orderJson.address != "" ? " / " + this.orderJson.address : ""}
                  </strong>
                  {this.orderJson.requestYn != null && this.orderJson.requestYn != "" ? (
                    <span className="newBm">신규</span>
                  ) : null}
                </h1>
                <p className="info">주문 상세 확인 후, 주문을 접수해주세요.</p>
              </div>
              <div className="order_btn">
                <button
                  type="button"
                  className="l"
                  onClick={event => {
                    fn_notify_close(this.rootStore, "baemin");
                  }}
                >
                  닫기
                </button>

                <button
                  type="button"
                  className="r detail"
                  onClick={event => {
                    localStorage.getItem("isCurrentPosBaeminUse") == "Y" &&
                    localStorage.getItem("connPosNo") == localStorage.getItem("baeminUsePosNo")
                      ? fn_bridge_new_order_notify_baemin(this.rootStore, this.orderJson)
                      : fn_bridge_new_detail_notify_baemin(this.rootStore, this.orderJson.mobileOrderNo);
                  }}
                >
                  주문 상세 보기
                </button>
              </div>
              <div className="close">
                <button type="button">
                  <span>닫기</span>
                </button>
              </div>
            </div>
          </>
        ) : (
          <div className="wrap_order">
            <div
              className="header"
              onClick={event => {
                fn_bridge_order_detail(this.rootStore, this.orderJson.mobileOrderNo);
              }}
            >
              <h1>
                <span className="img">
                  <img src={img_icon} width="32" height="32" alt={"logo"} />
                </span>
                {typeElement}
                <strong className="tit">
                  총 {comma(this.orderJson.orderTotAmount.toString())}원 / 메뉴 {this.orderJson.mainMenuCount}개
                </strong>
              </h1>
              <p className="menu_desc">
                {this.orderJson.mobileOrderFg == "31"
                  ? !this.orderJson.isInputCookingTime
                    ? "라이더 픽업 예상 시간을 확인해주세요"
                    : "조리시간을 입력해주세요"
                  : hungryPandaMobileOrderFg(this.orderJson.mobileOrderFg)
                  ? "조리시간을 입력해주세요"
                  : this.orderJson.mobileOrderFg == "27" && this.orderJson.morderTypeCd == "O"
                  ? "방문 예상 시간 및 인원을 확인해주세요"
                  : "고객 예상 수령 시간을 선택해주세요"}
              </p>
            </div>
            <div className="order_btn">
              <button
                type="button"
                className="l"
                onClick={event => {
                  fn_bridge_order_state(
                    this.rootStore,
                    this.orderJson.mobileOrderNo,
                    this.state.min,
                    this.orderJson.orderNo,
                    false,
                    this.orderJson.mobileOrderFg
                  );
                  analyticeEvent("orderCancel", "orderCancelPopup Button", localStorage.getItem("shopCd"));
                }}
              >
                거부
              </button>
              {this.orderJson.mobileOrderFg == "31" ? (
                !this.orderJson.isInputCookingTime ? (
                  <p className="fixed">라이더 픽업 예상 시간 : {this.orderJson.estimatedCookingTime + "분"}</p>
                ) : (
                  <span className="pm">
                    <button
                      type="button"
                      className={this.state.min == this.state.time[0] || this.state.min >= "30" ? "m disabled" : "m"}
                      onClick={this.ygyminMinus}
                    >
                      <span></span>
                    </button>
                    <span className="txt">{this.state.min + "분"}</span>
                    <button
                      type="button"
                      className={this.state.min >= "30" ? "p disabled" : "p"}
                      onClick={this.ygyminPlus}
                    >
                      <span></span>
                    </button>
                  </span>
                )
              ) : this.orderJson.mobileOrderFg == "27" && this.orderJson.morderTypeCd == "P" ? (
                this.orderJson.isInputCookingTime ? (
                  this.state.min > "60" ? (
                    <p className="fixed">픽업 예상 시간 {this.state.min + "분"} 후</p>
                  ) : (
                    <span className="pm">
                      <button
                        type="button"
                        className={this.state.min == this.state.time[0] || this.state.min > "60" ? "m disabled" : "m"}
                        onClick={this.ygyminMinus}
                      >
                        <span></span>
                      </button>
                      <span className="txt">{this.state.min + "분"}</span>
                      <button
                        type="button"
                        className={this.state.min >= "60" ? "p disabled" : "p"}
                        onClick={this.ygyminPlus}
                      >
                        <span></span>
                      </button>
                    </span>
                  )
                ) : (
                  <p className="fixed">픽업 예상 시간 {this.orderJson.expectedPickupTime}</p>
                )
              ) : this.orderJson.mobileOrderFg == "27" && this.orderJson.morderTypeCd == "O" ? (
                <p className="fixed">
                  {this.orderJson.expectedPickupTime + " 예약 주문  (" + this.orderJson.visitorCount + "명)"}
                </p>
              ) : (
                <span className="pm">
                  <button type="button" className="m" onClick={this.minMinus}>
                    <span></span>
                  </button>
                  <span className="txt">{this.state.min === 0 ? "즉시" : this.state.min + "분"}</span>
                  <button type="button" className="p" onClick={this.minPlus}>
                    <span></span>
                  </button>
                </span>
              )}
              <button
                type="button"
                className="r"
                onClick={event => {
                  fn_bridge_order_state(
                    this.rootStore,
                    this.orderJson.mobileOrderNo,
                    this.state.min,
                    this.orderJson.orderNo,
                    true,
                    this.orderJson.mobileOrderFg,
                    this.orderJson.morderTypeCd
                  );
                  analyticeEvent("orderAccept", "orderAcceptPopup Button", localStorage.getItem("shopCd"));
                }}
              >
                접수
              </button>
            </div>
            <div className="close">
              <button type="button">
                <span>닫기</span>
              </button>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default PosNotify;
